import { useState } from 'react';
import './FAQ.css';

const FAQ = () => {
  const [openQuestions, setOpenQuestions] = useState([]);

  const faqData = [
    {
      id: 1,
      question: "How long does it take to set up Dangol?",
      answer: "You can set up your basic rewards program with Dangol and be ready before you know it. Our platform is designed to be intuitive and the entire experience is done through our mobile app for your ease of use"
    },
    {
      id: 2,
      question: "Is Dangol complicated for my staff to use?",
      answer: "Not at all! The QR code system is incredibly simple for both staff and customers. Dangol provides clear instructions and support."
    },
    {
      id: 3,
      question: "Do my customers need to download an app to use Dangol?",
      answer: "Customers can easily join your loyalty program via Dangol and track basic rewards through our mobile Dangol App after scanning their QR code."
    },
    {
      id: 4,
      question: "What kind of support does Dangol offer?",
      answer: "Dangol offers email support, online knowledge base, phone support during business hours. We're here to help you succeed!"
    },
    {
      id: 5,
      question: "Is there a long-term contract with Dangol?",
      answer: "Dangol offers flexible plans and we are confident that you will see the benefits immediately."
    },
    {
      id: 6,
      question: "Can I customize the rewards with Dangol?",
      answer: "Absolutely! With Dangol, you have full control to set up rewards that make sense for your business and delight your customers."
    }
  ];

  const toggleQuestion = (questionId) => {
    setOpenQuestions(prevOpenQuestions => {
      if (prevOpenQuestions.includes(questionId)) {
        // If question is already open, close it
        return prevOpenQuestions.filter(id => id !== questionId);
      } else {
        // If question is closed, open it
        return [...prevOpenQuestions, questionId];
      }
    });
  };

  return (
    <section id="faq" className="faq">
      <div className="faq-container">
        <div className="faq-header reveal">
          <p className="faq-eyebrow">Frequently asked</p>
          <h2 className="faq-title">Things shop owners ask us.</h2>
        </div>

        <div className="faq-list reveal reveal-delay-1">
          {faqData.map((item) => (
            <div key={item.id} className="faq-item">
              <button 
                className="faq-question"
                onClick={() => toggleQuestion(item.id)}
                aria-expanded={openQuestions.includes(item.id)}
              >
                <span>{item.question}</span>
                <span className={`faq-arrow ${openQuestions.includes(item.id) ? 'open' : ''}`}>
                  ▼
                </span>
              </button>
              
              {openQuestions.includes(item.id) && (
                <div className="faq-answer">
                  <p>{item.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
        
        <div className="faq-contact-section">
          <h3 className="still-questions">Still have questions?</h3>
          <button className="contact-us-button" onClick={() => window.location.href = 'mailto:customersupport@dangolapp.com'}>Contact us</button>
        </div>

      </div>
    </section>
  );
};

export default FAQ;